import React from 'react'
import baseUrl from '../../../config/baseUrl'
import { Dialog, DialogContent, Typography, Stack, Button } from '@mui/material'
import { useSidebarContext } from '../../../contexts/Old_SidebarContext'
import { useNavigate } from 'react-router-dom'
import { useSnackbar } from '../../SnackbarProvider'

interface Props {
  open: boolean
  title: string
  onConfirm: () => void
  onClose: () => void
  threadIdToDelete: any
}

const DeleteConfirmationDialog = ({ open, title, onClose, onConfirm, threadIdToDelete }: Props) => {
  const userId: number = sessionStorage.getItem('userId') as unknown as number
  const token = sessionStorage.getItem('token')
  const navigate = useNavigate()
  const showSnackbar = useSnackbar()

  const { getUserHistory, setAllHistory, setIsThreadIdDelete, threadId } = useSidebarContext()

  const deleteHistory = async (threadIdToDelete: any) => {
    try {
      const deleteResponse = await fetch(
        `${baseUrl}/api/users/DeleteHistorynew/${threadIdToDelete as string}`,
        {
          method: 'DELETE',
          mode: 'cors',
          headers: {
            'Content-Type': 'application/json',
            authorization: token as string,
          },
        },
      )

      const deleteResponseData = await deleteResponse.json()

      if (deleteResponseData?.status === true) {
        setIsThreadIdDelete(true)
        showSnackbar(deleteResponseData?.message, 'success')
        if (threadId === threadIdToDelete) {
          navigate('/NewChat')
          setAllHistory([])
        }
        getUserHistory(userId)
      } else {
        showSnackbar(deleteResponseData?.message, 'error')
      }
    } catch (error: any) {
      showSnackbar('Something went wrong, not able to delete history', 'error')
    }
  }

  return (
    <Dialog open={open} fullWidth PaperProps={{ sx: { maxWidth: 456 } }}>
      <DialogContent
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          p: '36px 48px',
        }}
      >
        <Stack spacing={3.5}>
          <Typography variant='subtitle2' align='center' color='textSecondary'>
            {title}
          </Typography>
          <Stack direction='row' justifyContent='center' spacing={2} width={1}>
            <Button variant='outlined' sx={{ p: 0, maxWidth: 102, height: 44 }} onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant='contained'
              sx={{ p: 0, maxWidth: 102, height: 44 }}
              onClick={() => {
                onConfirm()
                deleteHistory(threadIdToDelete)
              }}
            >
              Confirm
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  )
}

export default DeleteConfirmationDialog
